import { Box } from '@mui/material';

const CoverImage = ({ src, dimension }: { src: string; dimension: number }) => {
  return (
    <Box
      sx={{
        width: dimension,
        height: dimension,
        mb: 1.5,
        borderRadius: 4,
        overflow: 'hidden',
        boxShadow: '0px 4px 12px 0px rgba(0, 0, 0, 0.65)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}>
      <Box
        component="img"
        alt="episode cover"
        src={src}
        sx={{ width: 'auto', height: '100%' }}
      />
    </Box>
  );
};

export default CoverImage;
